import { axiosInstance, axiosCompanyPortalInstance } from "./";

const getReason = async (params) =>
  await axiosInstance.get("/payroll_reasons", { params });

const getCompanyReason = async (params) =>
  await axiosCompanyPortalInstance.get("/payroll_reasons", { params });

const getSingleReason = async ({ id }) =>
  await axiosInstance.get(`/payroll_reasons/${id}`);

const updateReason = async ({ id, params }) =>
  await axiosInstance.patch(`/payroll_reasons/${id}/`, params);

export { getReason, getCompanyReason, getSingleReason, updateReason };
